var _path, _path2, _path3, _path4, _rect, _rect2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNetapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,70.75H70a.7502.7502,0,0,0,.75-.75V58h-1.5V69.25H10.75v-2.5H28a.7502.7502,0,0,0,.75-.75V62a.7502.7502,0,0,0-.75-.75H10.75V58H9.25V70A.7502.7502,0,0,0,10,70.75Zm.75-8h16.5v2.5H10.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,52.75H70a.7502.7502,0,0,0,.75-.75V40h-1.5V51.25H10.75v-2.5H28a.7502.7502,0,0,0,.75-.75V44a.7502.7502,0,0,0-.75-.75H10.75V40H9.25V52A.7502.7502,0,0,0,10,52.75Zm.75-8h16.5v2.5H10.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10,34.75H70a.7502.7502,0,0,0,.75-.75V22h-1.5V33.25H10.75V22H9.25V34A.7502.7502,0,0,0,10,34.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25,8V24.18945l-5.6084-5.6084L32.58105,19.6416l6.88868,6.88867a.74971.74971,0,0,0,1.06054,0L47.419,19.6416,46.3584,18.58105,40.75,24.18945V8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 63.25,
    width: 18,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 45.25,
    width: 18,
    height: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 46,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 64,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetapp);
export default __webpack_public_path__ + "static/media/icon_netapp.20e85486f38d82a9b3e2b05e7b3ce3b0.svg";
export { ForwardRef as ReactComponent };